import { render, staticRenderFns } from "./MentionConversationView.vue?vue&type=template&id=19620ce5&scoped=true"
import script from "./MentionConversationView.vue?vue&type=script&lang=js"
export * from "./MentionConversationView.vue?vue&type=script&lang=js"
import style0 from "./MentionConversationView.vue?vue&type=style&index=0&id=19620ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19620ce5",
  null
  
)

export default component.exports